import { useState } from 'react';
import { axiosInstance } from '../App';
import { toast } from 'sonner';

export function useCepLookup() {
  const [loadingCEP, setLoadingCEP] = useState(false);

  const buscarCEP = async (digits) => {
    if (!digits || digits.length !== 8) return null;
    setLoadingCEP(true);
    try {
      const { data } = await axiosInstance.get(`/cep/${digits}`);
      return data;
    } catch (err) {
      if (err.response?.status === 404) {
        toast.warning('CEP não encontrado. Preencha os dados manualmente.');
      } else {
        toast.warning('Não foi possível buscar os dados do CEP. Preencha manualmente.');
      }
      return null;
    } finally {
      setLoadingCEP(false);
    }
  };

  return { buscarCEP, loadingCEP };
}
